<aside class="feedback-widget" aria-label="Product feedback">
	<button class="feedback-trigger" type="button" (click)="open()">
		Feedback
	</button>

	<section
		*ngIf="state.feedbackOpen"
		class="feedback-panel"
		role="dialog"
		aria-label="Share feedback"
	>
		<div class="feedback-panel-header">
			<strong>Share feedback</strong>
			<button type="button" (click)="close()" aria-label="Close feedback">
				x
			</button>
		</div>

		<div
			*ngIf="state.feedbackSubmitted; else feedbackFormTpl"
			class="feedback-success"
		>
			<span class="status-badge success">Received</span>
			<h2>Thanks for helping shape App Launcher.</h2>
			<p>We've received your feedback.</p>
		</div>

		<ng-template #feedbackFormTpl>
			<form class="feedback-form" (ngSubmit)="submit()">
				<div class="field">
					<label for="feedbackType"
						>What kind of feedback is this?</label
					>
					<select
						id="feedbackType"
						name="feedbackType"
						[(ngModel)]="feedbackType"
					>
						<option>Confusing step</option>
						<option>Bug or issue</option>
						<option>Feature request</option>
						<option>General feedback</option>
					</select>
				</div>
				<div class="field">
					<label for="feedbackText">Tell us what happened</label>
					<textarea
						id="feedbackText"
						name="feedbackText"
						rows="4"
						placeholder="What should we know?"
						[(ngModel)]="feedbackText"
					></textarea>
				</div>
				<div class="field">
					<label for="feedbackEmail">Email</label>
					<input
						id="feedbackEmail"
						name="feedbackEmail"
						type="email"
						[(ngModel)]="feedbackEmail"
					/>
				</div>
				<button class="primary-button wide" type="submit">
					Send feedback
				</button>
			</form>
		</ng-template>
	</section>
</aside>
